import { Scope } from '@talpor/react-context-manager';

import { IStore } from '../index';

export interface IMiscActions extends Scope<IStore> {
  setLoading: (state: IStore) => (status: boolean) => IStore;
  setNotification: (state: IStore) => (data: any) => IStore;
}

export const miscActions: IMiscActions = {
  setLoading: (state: IStore) => (status: boolean) => {
    return {
      misc: {
        ...state.misc,
        loading: status,
      },
    } as IStore;
  },
  setNotification: (state: IStore) => (data: any) => {
    return {
      misc: {
        ...state.misc,
        notification: data,
      },
    } as IStore;
  },
};
